import { render } from "./FeedstocksWeightedAverage.vue?vue&type=template&id=7d15e1a3"
import script from "./FeedstocksWeightedAverage.vue?vue&type=script&lang=js"
export * from "./FeedstocksWeightedAverage.vue?vue&type=script&lang=js"

import "./FeedstocksWeightedAverage.vue?vue&type=style&index=0&id=7d15e1a3&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__